/** Speciality `key` whose records get the dermatology baseline block. */
export const DERMATOLOGY_SPECIALITY_KEY = 'dermatology';
